<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-form ref="form">
        <v-dialog v-if="isView" v-model="isView" persistent>        
            <v-card class="mt-3 pa-1">
                <Title title="通知の作成">
                    <v-spacer />
                    <TitleButton
                        v-if="enableSend"
                        color="primary"
                        icon="mdi-send"
                        name="送信"
                        @click="onClickSend" />
                    <TitleButton
                        color="primary"
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView=false" />
                </Title>
                <v-container fluid>
                    <template v-if="notification.to.targetType == 'reply'">
                        <v-row dense >
                            <v-col>
                                <v-text-field
                                    v-model="replyTargetNotification.sender.userName"
                                    readonly
                                    outlined
                                    label="宛先"
                                    hide-details
                                    dense />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else-if="notification.to.targetType == 'user'">
                        <v-row dense >
                            <v-col>
                                <v-text-field
                                    value="システム管理者"
                                    readonly
                                    outlined
                                    label="宛先"
                                    hide-details
                                    dense />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                    <!-- {type:"all", text:"全グループと全所属宛"},
                    {type:"group_all", text:"全グループ宛"},
                    {type:"group", text:"選択したグループ宛"},
                    {type:"group_member", text:"特定のグループのメンバー宛"},
                    {type:"belong_group_all", text:"全所属宛"},
                    {type:"belong_group", text:"選択した所属宛"},
                    {type:"belong_group_member", text:"特定の所属のメンバー宛"}, -->
                        <v-row dense v-if="['all','group_all','group','group_member','custom'].findIndex((v)=>v==notification.to.targetType)>=0">
                            <v-col>
                                <span class="body-2">
                                    <table>
                                        <tr>
                                            <td style="width:100%">通知対象のグループ</td>
                                            <td v-if="notification.to.targetType == 'custom'"><v-btn icon @click="onClickSelectAllGroups()"><v-icon>mdi-check-circle-outline</v-icon></v-btn></td>
                                        </tr>
                                    </table>
                                </span>
                                <v-card outlined class="mt-1">
                                    <v-card-text class="pa-1">
                                        <div v-if="notification.to.groups.length > 0" >
                                            <v-chip 
                                                v-for="group in notification.to.groups" 
                                                :key="group.data.body.groupNo" 
                                                class="ma-1"
                                                label
                                                :color="group.checked ? 'primary' : ''"
                                                @click="onClickGroup(group)">
                                                {{group.data.body.groupName}}
                                            </v-chip>
                                        </div>
                                        <span v-else class="caption red--text"><br/>グループは持っていません。</span>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row dense v-if="['all','belong_group_all','belong_group','belong_group_member','custom'].findIndex((v)=>v==notification.to.targetType)>=0">
                            <v-col>
                                <span class="body-2">
                                    <table>
                                        <tr>
                                            <td style="width:100%">通知対象の所属</td>
                                            <td v-if="notification.to.targetType == 'custom'"><v-btn icon @click="onClickSelectAllBelongGroups()"><v-icon>mdi-check-circle-outline</v-icon></v-btn></td>
                                        </tr>
                                    </table>
                                </span>
                                <v-card outlined class="mt-1">
                                    <v-card-text class="pa-1">
                                        <div v-if="notification.to.belongGroups.length > 0" >
                                            <v-chip 
                                                v-for="(group, index) in notification.to.belongGroups" 
                                                :key="index" 
                                                class="ma-1"
                                                label
                                                :color="group.checked ? 'primary' : ''"
                                                @click="onClickBelongGroup(group)">
                                                {{group.data.group.groupName}}
                                            </v-chip>
                                        </div>
                                        <span v-else class="caption red--text"><br/>所属しているグループはありません。</span>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="body-2">
                                    <table>
                                        <tr>
                                            <td style="width:100%">通知対象のユーザー</td>
                                            <td v-if="notification.to.targetType == 'custom'"><v-btn icon @click="onClickSelectAllUsers()"><v-icon>mdi-check-circle-outline</v-icon></v-btn></td>
                                        </tr>
                                    </table>
                                </span>
                                <v-card v-if="notification.to.users.length > 0" outlined class="mt-1" min-height="32">
                                    <v-card-text class="pa-1">
                                        <div>
                                            <template v-for="(user, index) in notification.to.users" >
                                                <v-chip
                                                    v-if="user.visible"
                                                    :key="index" 
                                                    class="ma-1"
                                                    label
                                                    :color="user.checked ? 'primary' : ''"
                                                    @click="onClickUser(user)">
                                                    {{user.groupType=="belong_group" ? "(所属)" : ""}}{{user.body.userInfo.userName}}
                                                </v-chip>
                                            </template>
                                        </div>
                                    </v-card-text>
                                </v-card>
                                <span style="font-size:xx-small">※ユーザーが重複する場合、そのユーザーには１通のみ通知されます。</span>
                            </v-col>
                        </v-row>
                    </template>
                </v-container>
                <v-divider />
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="12" xs="6" sm="4" md="4" lg="4" xl="2">
                            <v-select 
                                v-model="notification.notificationType" 
                                label="種類" 
                                outlined 
                                :items="notificationTypes" 
                                item-text="text" 
                                item-value="type"
                                hide-details
                                dense />
                        </v-col>
                        <v-col>
                            <v-text-field 
                                v-model="notification.title" 
                                clearable 
                                label="タイトル" 
                                outlined 
                                type="text" 
                                dense
                                persistent-hint
                                :rules="[validatorRequire]" />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12">
                            <v-textarea
                                v-model="notification.body"
                                label="通知内容"
                                rows="3"
                                outlined
                                clearable
                                auto-grow
                                persistent-hint
                                :rules="[validatorRequire]" />
                        </v-col>
                    </v-row>
                </v-container>
                <v-divider />
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="12">
                            <v-file-input 
                                v-model="attachedFile"
                                dense
                                clearable 
                                label="添付ファイル" 
                                outlined 
                                hide-details
                                class="mr-1"
                                :append-icon="attachedFile == null ? '' : 'mdi-plus-circle-outline'"
                                @change="onChangedAttachFile" />
                        </v-col>
                        <v-col cols="12">
                            <v-chip
                                v-for="file in attachedFiles" :key="file.importedDateTime" label color="primary" class="ma-1" close @click:close="onClickRemoveAttachedFile(file)">
                                {{file.body.name}}
                            </v-chip>
                        </v-col>
                    </v-row>
                </v-container>
                <v-divider />
                <v-container fluid>
                    <!-- 編集/表示兼用の画像一覧 -->
                    <v-row dense>
                        <Images v-model="images" />
                    </v-row>
                    <v-row v-if="replyHistories != null && replyHistories.length > 0">
                        <v-col class="pa-0">
                            <div v-for="(history, index) in replyHistories" :key="index">
                                <div class="d-flex flex-no-wrap">
                                    <v-avatar class="ml-2" rounded>
                                        <v-img v-if="history.userInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                        <v-img v-if="history.userInfo.avaterURL != null" :src="history.userInfo.avaterURL"/>
                                    </v-avatar>
                                    <div class="balloon2-left" style="margin-top:0px; margin-right:10px; width:100%">
                                        <v-card-text class="pa-1">
                                            <div class="subtitle-2 font-weight-bold mb-1">{{history.userInfo.userName}}</div>
                                            <div class="subtitle-2 font-weight-bold mb-1">{{history.body.content.title}}</div>
                                            <div class="body-2 mb-1" v-html="history.body.content.message.replace(/\r?\n/g, '<br>')" />
                                            <div class="caption text-right">{{history.body.dateTime}}</div>
                                        </v-card-text>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card> 
        </v-dialog>
        <Confirm ref="confirm" />
    </v-form>
</template>

<script>
    import fb from '@/firebase/firebase.js'
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Images from '@/components/tools/Images';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            Confirm,
            Title,
            TitleButton,
            Images
        },
        computed: {
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            /**
             * 自分の全グループ
             */
            groups: function () {
                return this.$store.getters["managementItems/groups"]
            },
            /**
             * 所属している全グループ
             */
            belongGroups: function () {
                return this.$store.getters["managementItems/belongGroups"]
            },
            /**
             * 送信ボタンを有効にするか否か
             */
            enableSend: function () {
                if (this.notification.to.targetType == "reply" || this.notification.to.targetType == "user") {
                    return true
                }
                if (this.notification.to.users.findIndex((v)=>v.checked && v.visible) < 0) {
                    return false
                }
                return true
            }
        },
        data: function () {
            return {
                isView: false,
                isInitializing: false,
                notification: {
                    to: {
                        targetType: "",
                        groups: [],                        
                        belongGroups: [],
                        users: []
                    },
                    body: "",
                    notificationType: 0,
                    title: "",
                    // histories: []
                },
                targetTypes: [
                    {type:"all", text:"全グループと全所属宛"},
                    {type:"group_all", text:"全グループ宛"},
                    {type:"group", text:"選択したグループ宛"},
                    {type:"group_member", text:"特定のグループのメンバー宛"},
                    {type:"belong_group_all", text:"全所属宛"},
                    {type:"belong_group", text:"選択した所属宛"},
                    {type:"belong_group_member", text:"特定の所属のメンバー宛"},
                ],
                notificationTypes: [
                    {type:0, text:"連絡", icon:"mdi-information"},
                    {type:1, text:"緊急", icon:"mdi-alert-circle"}
                ],
                /** 添付画像 */
                images: [],
                attachedFile: null,
                attachedFiles: [],
                /** リプライ対象の通知 */
                replyTargetNotification: null,
                /** 表示用の履歴("reply"時) */
                replyHistories: null,
                /** 宛先のユーザーによる変更可否(通知管理から通知作成時はtrue。 その他、グループ管理などからの通知作成時は false) */
                canToChanged: true,
                validatorRequire: value => !!value || '必須入力です。',
                validatorTitleLength: value => value.length <= 20 || '20文字以内で入力して下さい。',
            }
        },
        mounted: function () {
            let inputs = document.querySelectorAll('.v-file-input input');
            [...inputs].forEach((input) => {
                input.remove()
            })
        },
        methods: {
            /**
             * ファイル選択時
             */
            onChangedAttachFile: function () {
                console.log("onChangedAttachFile", this.attachedFile)

                if (this.attachedFile == undefined) {
                    return
                }
                
                const file = {
                    body: this.attachedFile,
                    data: "",
                    importedDateTime: this.df_currentDateTime()
                }
                this.attachedFiles.push(file)

                console.log(file)

                const reader = new FileReader()
                reader.onload = function () {
                    file.data = reader.result
                }
                reader.readAsDataURL(this.attachedFile)
            },
            // /**
            //  * ファイル追加ボタン押下時
            //  */
            // onClickAddAttachFile: function () {
            //     console.log("onClickAddAttachFile", this.attachedFile)

            //     const file = {
            //         body: this.attachedFile,
            //         data: "",
            //         importedDateTime: this.df_currentDateTime()
            //     }
            //     this.attachedFiles.push(file)

            //     console.log(file)

            //     const reader = new FileReader()
            //     reader.onload = function () {
            //         file.data = reader.result
            //     }
            //     reader.readAsDataURL(this.attachedFile)

            //     this.attachedFile = null
            // },
            /**
             * 添付ファイルの削除ボタン押下時
             */
            onClickRemoveAttachedFile: function (file) {
                const index = this.attachedFiles.findIndex((v)=>v.importedDateTime == file.importedDateTime)
                this.attachedFiles.splice(index, 1)
            },
            /**
             * グループの全選択ボタン押下時
             */
            onClickSelectAllGroups: function () {
                for (var i=0; i<this.notification.to.groups.length; i++) {
                    this.notification.to.groups[i].checked = true
                }
                this.refreshUserVisibleState()
            },
            /**
             * 所属グループの全選択ボタン押下時
             */
            onClickSelectAllBelongGroups: function () {
                for (var i=0; i<this.notification.to.belongGroups.length; i++) {
                    this.notification.to.belongGroups[i].checked = true
                }
                this.refreshUserVisibleState()
            },
            /**
             * ユーザーの全選択ボタン押下時
             */
            onClickSelectAllUsers: function () {
                for (var i=0; i<this.notification.to.users.length; i++) {
                    if (this.notification.to.users[i].visible) {
                        this.notification.to.users[i].checked = true
                    }
                }
            },
            /**
             * 通知ボタン押下時
             */
            onClickSend: function () {
                const self = this
                if (!this.$refs.form.validate()) {
                    this.$refs.confirm.show({
                        title: "入力エラー",
                        message: "入力項目を確認して下さい。",
                        width: 400,
                        buttonYes: "入力に戻る",
                        buttonNo: "",
                    })
                    return
                }

                this.$refs.confirm.show({
                    title: "送信確認",
                    message: "送信しますか？",
                    width: 400,
                    buttonYes: "送信する",
                    buttonNo: "送信しない",
                    listenerYes: function () {
                        self.$store.commit("processing", {start:true, message:"通知を送信しています。"})
                        self.createSendNotification()
                        return true
                    }
                })
            },

            //     this.onSelectedTargetType()
            // },
            /**
             * グループが押下された時
             */
            onClickGroup: function (group) {

                if (!this.canToChanged) return

                group.checked = !group.checked

                this.refreshUserVisibleState()

            },
            /**
             * 所属グループが押下された時
             */
            onClickBelongGroup: function (group) {

                if (!this.canToChanged) return

                group.checked = !group.checked

                this.refreshUserVisibleState()

            },
            /**
             * ユーザーが押下された時
             */
            onClickUser: function (user) {
                if (!this.canToChanged) return

                user.checked = !user.checked
            },
            /**
             * グループの配列を初期化
             */
            initializeGroups: function (checked) {
                const self = this
                this.notification.to.groups = []
                for (var i=0; i<this.groups.length; i++) {
                    const group = this.groups[i]
                    self.notification.to.groups.push(
                        {
                            data: group,
                            checked: checked
                        }
                    )
                }
                console.log("initializeGroups completed")
            },
            /**
             * 所属グループの配列を初期化
             */
            initializeBelongGroups: function (checked) {
                const self = this
                this.notification.to.belongGroups = []
                for (var i=0; i<this.belongGroups.length; i++) {
                    const group = this.belongGroups[i]
                    self.notification.to.belongGroups.push(
                        {
                            data: group,
                            checked: checked
                        }
                    )
                }
            },
            /**
             * ユーザーの配列を初期化
             */
            initializeUsers: function (checked) {
                const self = this                
                this.notification.to.users = []
                if (this.notification.to.groups.length > 0) {
                    for (var i=0; i<this.notification.to.groups.length; i++) {
                        const group = this.notification.to.groups[i]
                        for (var j=0; j<group.data.users.length; j++) {
                            const user = group.data.users[j]
                            if (user.body.userUID != self.userUID) { // && self.notification.to.users.find((v)=>v.body.body.userUID == user.body.userUID) == null) {
                                self.notification.to.users.push(
                                    {
                                        body: user,
                                        checked: checked,
                                        visible: false,
                                        groupType: "group",
                                        group: group
                                    }
                                )
                            }
                        }
                    }
                }
                if (this.notification.to.belongGroups.length > 0) {
                    for (var i=0; i<this.notification.to.belongGroups.length; i++) {
                        const group = this.notification.to.belongGroups[i]
                        for (var j=0; j<group.data.users.length; j++) {
                            const user = group.data.users[j]
                            if (user.body.userUID != self.userUID) { // && self.notification.to.users.find((v)=>v.body.body.userUID == user.body.userUID) == null) {
                                self.notification.to.users.push(
                                    {
                                        body: user,
                                        checked: checked,
                                        visible: false,
                                        groupType: "belong_group",
                                        group: group
                                    }
                                )
                            }
                        }
                    }
                }
            },
            /**
             * ユーザーの表示/非表示を更新
             */
            refreshUserVisibleState: function () {
                this.notification.to.users.forEach(function(user){
                    user.visible = user.group.checked
                })
            },
            /**
             * 指定されたグループを選択状態に設定
             * groupNo == null の時は、全グループを選択状態にする
             */
            checkGroup: function (groupNo) {
                if (groupNo != null) {
                    const targetGroup = this.notification.to.groups.find((v)=>v.data.body.groupNo == groupNo)
                    targetGroup.checked = true
                    return
                }
                for (var i=0; i<this.notification.to.groups.length; i++) {
                    this.notification.to.groups[i].checked = true
                }
            },
            /**
             * 指定された所属グループを選択状態に設定
             * params == null の時は、全グループを選択状態にする
             */
            checkBelongGroup: function (params) {
                if (params != null) {
                    const targetGroup = this.notification.to.belongGroups.find((v)=>v.data.body.ownerUserUID == params.userUID && v.data.body.groupNo == params.groupNo)
                    targetGroup.checked = true
                    return
                }
                for (var i=0; i<this.notification.to.belongGroups.length; i++) {
                    this.notification.to.belongGroups[i].checked = true
                }
            },
            /**
             * グループユーザーの選択状態を設定する
             * userUID == null の時:
             *     現在選択されている全グループのユーザーを選択状態にする
             *     (選択されていないグループのユーザーは選択解除)
             * userUID != null の時:
             *     指定されたユーザー
             */
            checkUser: function (userUID) {
                this.notification.to.users.forEach(function(user){
                    if (user.groupType == "group") {
                        if (userUID == null || user.body.body.userUID == userUID) {
                            user.checked = user.group.checked
                        }
                    }
                })
            },
            /**
             * グループユーザーの選択状態を設定する
             * params == null の時:
             *     現在選択されている全グループのユーザーを選択状態にする
             *     (選択されていないグループのユーザーは選択解除)
             * params != null の時:
             *     指定されたユーザー
             */
            checkBelongUser: function (params) {
                console.log(params)
                this.notification.to.users.forEach(function(user){
                    if (user.groupType == "belong_group") {
                        if (params == null || (user.body.body.userUID == params.userUID && user.group.data.body.ownerUserUID == params.ownerUserUID && user.group.data.body.groupNo == params.groupNo)) {
                            user.checked = user.group.checked
                        }
                    }
                })
            },
            /**
             * このダイアログを表示
             * to: {
             *     type:
             * 
             *     type="group": (特定のグループへの通知作成)
             *     groups:[groupNo]
             *
             *     type="belong_group": (特定の所属グループへの通知作成)
             *     groups:[
             *         {
             *             userUID,
             *             groupNo
             *         }
             *     ]
             *
             *     type="group_member": (特定のグループのメンバーへの通知作成)
             *     groupNo: 
             *     users: [userUID]
             *
             *     type="belong_group_member": (特定の所属グループのメンバーへの通知作成)
             *     ownerUserUID:
             *     groupNo: 
             *     users: [userUID]
             *
             *     type="reply": 受信した通知からの返信
             *     notification:
             * }
             */
            show: function (to) {

                console.log("NotificationCreator", "show", to)

                const self = this

                // 初期化中
                this.isInitializing = true

                this.notification.to.targetType = ""
                this.notification.body = ""
                this.notification.title = ""
                this.notification.histories = []
                this.attachedFiles = []

                // this.histories = []

                // グループ、所属グループ及びユーザーを初期化
                this.initializeGroups(false)
                this.initializeBelongGroups(false)
                this.initializeUsers(false)

                // 引数で宛先が指定されている時
                if (to != null) {

                    this.canToChanged = false
                    this.notification.to.targetType = to.type

                    switch (to.type) {
                        case "group":
                            to.groups.forEach(function(groupNo){
                                self.checkGroup(groupNo)
                            })
                            this.refreshUserVisibleState()
                            this.checkUser()
                            break;

                        case "belong_group":
                            to.groups.forEach(function(params){
                                self.checkBelongGroup(params)
                            })
                            this.refreshUserVisibleState()
                            this.checkBelongUser()
                            break;

                        case "group_member":
                            this.checkGroup(to.groupNo)
                            this.refreshUserVisibleState()
                            to.users.forEach(function(userUID) {
                                self.checkUser(userUID)
                            })
                            break;

                        case "belong_group_member":
                            this.checkBelongGroup(
                                {
                                    userUID: to.ownerUserUID,
                                    groupNo: to.groupNo
                                }
                            )
                            this.refreshUserVisibleState()
                            to.users.forEach(function(userUID) {
                                self.checkBelongUser(
                                    {
                                        ownerUserUID: to.ownerUserUID,
                                        userUID: userUID,
                                        groupNo: to.groupNo
                                    }
                                )
                            })
                            break;
                        
                        case "reply":
                            this.replyTargetNotification = to.notification
                            this.notification.to.targetType = "reply"
                            if (to.notification.body.histories != null && to.notification.body.histories.length > 0) {
                                for (var i=0; i<to.notification.body.histories.length; i++) {
                                    this.notification.histories.push(to.notification.body.histories[i])
                                }
                            }
                            this.notification.histories.push(
                                {
                                    notificationID: to.notification.body.notificationID,
                                    dateTime: to.notification.body.dateTime,
                                    sender: {
                                        userUID: to.notification.body.sender.userUID
                                    },
                                    content: {
                                        title: to.notification.body.content.title,
                                        message: to.notification.body.content.message
                                    }
                                }
                            )
                            this.replyHistories = []
                            for (var i=this.notification.histories.length-1; i>=0; i--) {
                                const history = this.notification.histories[i]
                                const historyData = {
                                    body: history,
                                    userInfo: {
                                        userName: "",
                                        avaterURL: ""
                                    }
                                }
                                self.mi_userData(historyData.body.sender.userUID, historyData.userInfo)
                                self.replyHistories.push(historyData)
                            }

                            this.notification.title = "Re: " + to.notification.body.content.title
                            break;

                        case "user":
                            break;
                    }
                } else {
                    this.notification.to.targetType = "custom"
                    this.canToChanged = true
                }

                this.isView = true
            },
            // // to: {
            // //     type:
            // // 
            // //     type="group": (特定のグループへの通知作成)
            // //     groups:[groupNo]
            // //
            // //     type="belong_group": (特定の所属グループへの通知作成)
            // //     groups:[
            // //         {
            // //             userUID,
            // //             groupNo
            // //         }
            // //     ]
            // //
            // //     type="group_member": (特定のグループのメンバーへの通知作成)
            // //     groupNo: 
            // //     users: [userUID]
            // //
            // //     type="belong_group_member": (特定の所属グループのメンバーへの通知作成)
            // //     ownerUserUID:
            // //     groupNo: 
            // //     users: [userUID]
            // //
            // //     type="reply": 受信した通知からの返信
            // //     notification:
            // // }
            // show_old: function (to) {
            //     console.log("NotificationCreator.show", to)

            //     const self = this

            //     this.isInitializing = true

            //     try {
            //         this.notification.to.targetType = ""
            //         this.notification.body = ""
            //         this.notification.title = ""
            //         this.histories = []
                    
            //         if (to != null) {

            //             this.canToChanged = false   // to が指定されている時は、宛先の変更を不可とする

            //             this.notification.to.targetType = to.type
            //             this.onSelectedTargetType()

            //             // if (to.type == "reply") {
            //             //         this.targetTypes.push(
            //             //             {
            //             //                 type: "reply",
            //             //                 text: to.notification.sender.userName
            //             //             }
            //             //         )
            //             // }

            //             switch (to.type) {
            //                 case "group":
            //                     to.groups.forEach(function(groupNo) {
            //                         const targetGroup = self.notification.to.groups.find((v)=>v.data.body.groupNo == groupNo)
            //                         if (targetGroup != null) {
            //                             targetGroup.checked = true
            //                         }
            //                     })
            //                     break;
            //                 case "belong_group":
            //                     to.groups.forEach(function(group) {
            //                         const targetGroup = self.notification.to.belongGroups.find((v)=>v.data.body.ownerUserUID == group.userUID && v.data.body.groupNo == group.groupNo)
            //                         if (targetGroup != null) {
            //                             targetGroup.checked = true
            //                         }
            //                     })
            //                     break;
            //                 case "group_member":
            //                     const targetGroup = self.notification.to.groups.find((v)=>v.data.body.groupNo == to.groupNo)
            //                     if (targetGroup != null) {
            //                         targetGroup.checked = true
            //                         this.initializeGroupMembers(targetGroup, false)
            //                         to.users.forEach(function(userUID) {
            //                             const targetUser = self.notification.to.groupMembers.find((v)=>v.data.body.userUID == userUID)
            //                             if (targetUser != null) {
            //                                 targetUser.checked = true
            //                             }
            //                         })
            //                     } else {
            //                         console.log("unknown group")
            //                     }
            //                     break;
            //                 case "belong_group_member":
            //                     // console.log(self.notification.to.belongGroups)
            //                     const targetBelongGroup = self.notification.to.belongGroups.find((v)=>v.data.body.ownerUserUID == to.ownerUserUID && v.data.body.groupNo == to.groupNo)
            //                     if (targetBelongGroup != null) {
            //                         targetBelongGroup.checked = true
            //                         this.initializeBelongGroupMembers(targetBelongGroup, false)
            //                         to.users.forEach(function(userUID) {
            //                             const targetUser = self.notification.to.belongGroupMembers.find((v)=>v.data.body.userUID == userUID)
            //                             if (targetUser != null) {
            //                                 targetUser.checked = true
            //                             } else {
            //                                 console.log("unknown user")
            //                             }
            //                         })
            //                     } else {
            //                         console.log("unknown group")
            //                     }
            //                     break;
            //                 case "reply":
            //                     this.replyTargetNotification = to.notification
            //                     this.targetTypes.push(
            //                         {
            //                             type: "reply",
            //                             text: to.notification.sender.userName
            //                         }
            //                     )
            //                     if (to.notification.body.histories != null && to.notification.body.histories.length > 0) {
            //                         for (var i=0; i<to.notification.body.histories.length; i++) {
            //                             this.notification.histories.push(to.notification.body.histories[i])
            //                         }
            //                     }
            //                     this.notification.histories.push(
            //                         {
            //                             notificationID: to.notification.body.notificationID,
            //                             dateTime: to.notification.body.dateTime,
            //                             sender: {
            //                                 userUID: to.notification.body.sender.userUID
            //                             },
            //                             content: {
            //                                 title: to.notification.body.content.title,
            //                                 message: to.notification.body.content.message
            //                             }
            //                         }
            //                     )
            //                     this.replyHistories = []
            //                     for (var i=this.notification.histories.length-1; i>=0; i--) {
            //                         const history = this.notification.histories[i]
            //                         const historyData = {
            //                             body: history,
            //                             userInfo: {
            //                                 userName: "",
            //                                 avaterURL: ""
            //                             }
            //                         }
            //                         self.mi_userData(historyData.body.sender.userUID, historyData.userInfo)
            //                         self.replyHistories.push(historyData)
            //                     }
            //                     // this.notification.histories.forEach(function(history){
            //                     //     const historyData = {
            //                     //         body: history,
            //                     //         userInfo: {
            //                     //             userName: "",
            //                     //             avaterURL: ""
            //                     //         }
            //                     //     }
            //                     //     self.mi_userData(historyData.body.sender.userUID, historyData.userInfo)
            //                     //     self.replyHistories.push(historyData)
            //                     // })

            //                     this.notification.title = "Re: " + to.notification.body.content.title
            //                     break;
            //                     // {type:"belong_group_member", text:"特定の所属グループのメンバー宛"},
                                
            //             }
            //         }

            //         this.isView = true

            //     } finally {
            //         this.isInitializing = false
            //     }
            // },
            /**
             * 通知作成
             */
            createSendNotification: function () {

                const self = this
                const userUID = this.$store.getters["userUID"]
                const id = this.df_currentDateTime("yyyyMMddHHmmss")

                // 通知
                const notification = {
                    version: "1.0.1",
                    notificationID: id,
                    dateTime: this.df_currentDateTime(),
                    sender: {
                        userUID: userUID
                    },
                    content: {
                        type: this.notification.to.targetType=='user' ? 90 : 13,
                        title: this.notification.title,
                        message: this.notification.body
                    },
                    data: {
                        type: this.notification.notificationType,
                    },
                    histories: this.notification.histories,
                    attachedFiles: [],
                    openedDateTime: ""
                }

                // 添付データの種類を取得するファンクション
                const dataTypeGetter = function(base64) {
                    const i = base64.indexOf("/")
                    const j = base64.indexOf(";")
                    const type = base64.substr(i+1, j-i-1)
                    return type
                }

                // 画像のアップロードを行うファンクション
                const imageUploader = function (completeListener) {
                    console.log("画像のアップロード開始")

                    // 画像をアップロードしてURLを取得し、通知に格納
                    try {
                        for(var i=0; i<self.images.length; i++) {

                            var uploadedFileNum = 0

                            const editImage = self.images[i]
                            const imageType = dataTypeGetter(editImage.image)
                            const filename = editImage.capturedDate.replace(/\-/g, '').replace(/:/g, '').replace(/ /g, '')
                            const uploadUrl = "notification_attached_files/users/" + userUID + "/notifications/" + notification.notificationID + "/" + filename

                            const storage = fb.storage().ref()
                            const outputRef = storage.child(uploadUrl)

                            const startIndex = editImage.image.indexOf(",") + 1
                            outputRef.putString(editImage.image.substring(startIndex), 'base64').then(function(snapShot){
                                snapShot.ref.getDownloadURL().then (function(url){
                                    notification.attachedFiles.push(
                                        {
                                            url: url,
                                            type: imageType
                                        }
                                    )
                                    uploadedFileNum++
                                    if (uploadedFileNum == self.images.length) {
                                        completeListener()
                                    }
                                }).catch(function(error){
                                    console.log("画像のURL取得失敗", error)
                                })
                            }).catch(function(error){
                                console.log("画像のアップロード失敗", error)
                            })
                        }
                    } finally {
                    }
                }

                // 添付ファイルのアップロードを行うファンクション
                const fileUploader = function () {
                    console.log("ファイルのアップロード開始")

                    // ファイルをアップロードしてURLを取得し、通知に格納
                    try {
                        for(var i=0; i<self.attachedFiles.length; i++) {

                            var uploadedFileNum = 0

                            const file = self.attachedFiles[i]
                            const dataType = dataTypeGetter(file.data)
                            const filename = file.body.name
                            const uploadUrl = "notification_attached_files/users/" + userUID + "/notifications/" + notification.notificationID + "/" + filename

                            const storage = fb.storage().ref()
                            const outputRef = storage.child(uploadUrl)

                            const startIndex = file.data.indexOf(",") + 1
                            outputRef.putString(file.data.substring(startIndex), 'base64').then(function(snapShot){
                                snapShot.ref.getDownloadURL().then (function(url){
                                    notification.attachedFiles.push(
                                        {
                                            url: url,
                                            type: dataType,
                                            filename: filename
                                        }
                                    )
                                    uploadedFileNum++
                                    if (uploadedFileNum == self.attachedFiles.length) {
                                        self.send(notification)
                                    }
                                }).catch(function(error){
                                    console.log("ファイルのURL取得失敗", error)
                                })
                            }).catch(function(error){
                                console.log("ファイルのアップロード失敗", error)
                            })
                        }
                    } finally {
                    }
                }

                // 添付画像とファイルがなければ、送信処理へ
                if (this.images.length == 0 && this.attachedFiles.length == 0) {
                    console.log("画像、ファイル共に添付無し")
                    this.send(notification)
                    return
                }

                // 添付画像のアップロード
                if (this.images.length > 0) {
                    console.log("画像添付有り")
                    imageUploader(
                        // 画像のアップロード終了時
                        function () {
                            if (self.attachedFiles.length > 0) {
                                console.log("ファイル添付有り")
                                // 添付ファイルがあれば、それのアップロード処理へ
                                fileUploader()
                            } else {
                                // 添付ファイルがなければ、送信処理へ
                                console.log("ファイル添付無し")
                                self.send(notification)
                            }
                        }
                    )
                }

                // 添付ファイルのアップロード
                if (this.images.length == 0 && this.attachedFiles.length > 0) {
                    console.log("ファイル添付有り")
                    fileUploader()
                }
            },
            /**
             * 通知送信
             */
            send: async function (notification) {
                
                const self = this
                const userUID = this.$store.getters["userUID"]
                const id = notification.notificationID

                // 送信対象となったユーザーのUIDを格納する配列
                // 設定によって同一ユーザーに送信する事になってしまうので、それを避ける為に
                // ここにセットされているユーザーUIDのユーザーには送信しない
                const userList = []

                const sendGroupUserSetter = function (array, users) {
                    for (var i=0; i<users.length; i++) {
                        if (users[i].body.userUID != self.userUID &&  userList.find((v)=>v==users[i].body.userUID) == null) {
                            array.push(users[i].body.userUID)
                            userList.push(users[i].body.userUID)
                        }
                    }
                }

                // 送信履歴作成
                var sentNotificationHistory = {
                    version: "1.0.0",
                    type: self.notification.to.targetType,
                    to: null,
                    notification: notification
                }

                switch(this.notification.to.targetType){
                    case "all":
                    case "group_all":
                    case "belong_group_all":
                    case "group":
                    case "belong_group":
                    case "custom":
                        sentNotificationHistory.to = {
                            groups: []
                        }
                        // 全グループから選択されているグループに対して処理を行う
                        for (var i=0; i<this.notification.to.groups.length; i++) {
                            const group = this.notification.to.groups[i]
                            if (group.checked) {
                                // チェックされているグループから、配列に格納するデータを作成
                                const sentGroup = {
                                    userUID: group.data.body.ownerUserUID,
                                    groupNo: group.data.body.groupNo,
                                    users: []
                                }
                                // チェックされているグループのユーザーでチェックされているユーザーを抽出して配列に格納
                                for (var j=0; j<this.notification.to.users.length; j++) {
                                    const user = this.notification.to.users[j]
                                    if (userList.find((v)=>v == user.body.body.userUID) == null && user.group == group && user.checked && user.visible) {
                                        sentGroup.users.push(user.body.body.userUID)
                                        userList.push(user.body.body.userUID)
                                    }
                                }
                                // 送信先のユーザーがいる時は、配列に格納
                                if (sentGroup.users.length > 0) {
                                    sentNotificationHistory.to.groups.push(sentGroup)
                                }
                            }
                        }
                        // 全所属グループから選択されているグループに対して処理を行う
                        for (var i=0; i<this.notification.to.belongGroups.length; i++) {
                            const group = this.notification.to.belongGroups[i]
                            if (group.checked) {
                                // チェックされているグループから、配列に格納するデータを作成
                                const sentGroup = {
                                    userUID: group.data.body.ownerUserUID,
                                    groupNo: group.data.body.groupNo,
                                    users: []
                                }
                                // チェックされているグループのユーザーでチェックされているユーザーを抽出して配列に格納
                                for (var j=0; j<this.notification.to.users.length; j++) {
                                    const user = this.notification.to.users[j]
                                    if (userList.find((v)=>v == user.body.body.userUID) == null && user.group == group && user.checked && user.visible) {
                                        sentGroup.users.push(user.body.body.userUID)
                                        userList.push(user.body.body.userUID)
                                    }
                                }
                                // 送信先のユーザーがいる時は、配列に格納
                                if (sentGroup.users.length > 0) {
                                    sentNotificationHistory.to.groups.push(sentGroup)
                                }
                            }
                        }
                        break;

                    case "group_member":
                    case "belong_group_member":
                        sentNotificationHistory.to = {
                            users: []
                        }
                        for (var i=0; i<this.notification.to.users.length; i++) {
                            const user = this.notification.to.users[i]
                            if (userList.find((v)=>v == user.body.body.userUID) == null && user.checked && user.visible) {
                                sentNotificationHistory.to.users.push(user.body.body.userUID)
                                userList.push(user.body.body.userUID)
                            }
                        }
                        break;

                    case "reply":
                        // 返信の時の、to のデータを作成
                        sentNotificationHistory.to = {
                            userUID: this.replyTargetNotification.body.sender.userUID 
                        }
                        break;

                    case "user":
                        sentNotificationHistory.to = {
                            userUID: "ggtYQkhDi8M4FlQ2SIiugbof7qf1"
                        }
                        break;
                }

                console.log("NotificationCreator", "send", this.notification.to.targetType, sentNotificationHistory)

                try {
                    var batch = db.batch()

                    // 通知を登録
                    switch (this.notification.to.targetType) {
                        case "all":
                        case "group_all":
                        case "group":
                        case "belong_group_all":
                        case "belong_group":
                        case "custom":
                            for (var i=0; i<sentNotificationHistory.to.groups.length; i++) {
                                const group = sentNotificationHistory.to.groups[i]
                                for (var j=0; j<group.users.length; j++) {
                                    const userUID = group.users[j]
                                    batch.set(db.collection("users").doc(userUID).collection("notifications").doc(id), notification)
                                }
                            }
                            break;
                        case "group_member":
                            for (var i=0; i<sentNotificationHistory.to.users.length; i++) {
                                const userUID = sentNotificationHistory.to.users[i]
                                batch.set(db.collection("users").doc(userUID).collection("notifications").doc(id), notification)
                            }
                            break;
                        case "belong_group_member":
                            for (var i=0; i<sentNotificationHistory.to.users.length; i++) {
                                const userUID = sentNotificationHistory.to.users[i]
                                batch.set(db.collection("users").doc(userUID).collection("notifications").doc(id), notification)
                            }
                            break;
                        case "reply":
                            batch.set(db.collection("users").doc(this.replyTargetNotification.body.sender.userUID).collection("notifications").doc(id), notification)
                            break;
                        case "user":
                            batch.set(db.collection("users").doc(sentNotificationHistory.to.userUID).collection("notifications").doc(id), notification)
                            break;
                    }
                    
                    // 通知の送信履歴
                    console.log("NotificationCreator", "send", "sent history", sentNotificationHistory)
                    batch.set(db.collection("users").doc(this.userUID).collection("sent_notifications").doc(id), sentNotificationHistory)

                    // コミット
                    batch.commit().then(function(){
                        console.log("通知成功")
                        self.$store.commit("notification", {message:"通知を送信しました。"})
                        self.$store.commit("processing")
                        self.$emit("onSentNotification", sentNotificationHistory)
                        self.isView = false
                    }).catch (function(error){
                        console.log(error)
                        self.$store.commit("notification", {message:"通知の送信に失敗しました。", isError:true})
                        self.$store.commit("processing")
                    })
                } catch (error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"通知の送信に失敗しました。", isError:true})
                    self.$store.commit("processing")
                }

            },
            /**
             * 通知送信
             */
            send_old: async function (notification) {
                
                const self = this
                const userUID = this.$store.getters["userUID"]
                const id = notification.notificationID

                // 送信対象となったユーザーのUIDを格納する配列
                // 設定によって同一ユーザーに送信する事になってしまうので、それを避ける為に
                // ここにセットされているユーザーUIDのユーザーには送信しない
                const userList = []

                const sendGroupUserSetter = function (array, users) {
                    for (var i=0; i<users.length; i++) {
                        if (users[i].body.userUID != self.userUID &&  userList.find((v)=>v==users[i].body.userUID) == null) {
                            array.push(users[i].body.userUID)
                            userList.push(users[i].body.userUID)
                        }
                    }
                }
                // 送信履歴作成
                var sentNotificationHistory = {
                    version: "1.0.0",
                    type: self.notification.to.targetType,
                    to: null,
                    notification: notification
                }

                // {type:"all", text:"全グループと全所属グループ宛"},
                // {type:"group_all", text:"全グループ宛"},
                // {type:"group", text:"選択したグループ宛"},
                // {type:"group_member", text:"特定のグループのメンバー宛"},
                // {type:"belong_group_all", text:"全所属グループ宛"},
                // {type:"belong_group", text:"選択した所属グループ宛"},
                // {type:"belong_group_member", text:"特定の所属グループのメンバー宛"},
                
                switch(this.notification.to.targetType){
                    case "all":
                    case "group_all":
                    case "belong_group_all":
                        // 全グループと全所属グループ宛
                        // 全グループ宛
                        // 全所属グループ宛
                        // 上記いずれかの時の、to のデータを作成
                        sentNotificationHistory.to = {
                            groups: []
                        }
                        if (this.notification.to.targetType == "all" || this.notification.to.targetType == "group_all") {
                            for(var i=0; i<this.groups.length; i++){   
                                const sentGroup = {
                                    userUID: this.groups[i].body.ownerUserUID,
                                    groupNo: this.groups[i].body.groupNo,
                                    users: []
                                }                         
                                sendGroupUserSetter(sentGroup.users, this.groups[i].users)
                                if (sentGroup.users.length > 0) {
                                    sentNotificationHistory.to.groups.push(sentGroup)
                                }
                            }
                        }
                        if (this.notification.to.targetType == "all" || this.notification.to.targetType == "belong_group_all") {
                            for(var i=0; i<this.belongGroups.length; i++){   
                                const sentGroup = {
                                    userUID: this.belongGroups[i].group.ownerUserUID,
                                    groupNo: this.belongGroups[i].group.groupNo,
                                    users: []
                                }
                                sendGroupUserSetter(sentGroup.users, this.belongGroups[i].users)
                                if (sentGroup.users.length > 0) {
                                    sentNotificationHistory.to.groups.push(sentGroup)
                                }
                            }                            
                        }
                        break;
                    case "group":
                        // 選択したグループ宛 の時の、to のデータを作成
                        sentNotificationHistory.to = {
                            groups: []
                        }
                        for (var i=0; i<this.notification.to.groups.length; i++) {
                            if (this.notification.to.groups[i].checked) {
                                const sentGroup = {
                                    userUID: this.notification.to.groups[i].data.body.ownerUserUID,
                                    groupNo: this.notification.to.groups[i].data.body.groupNo,
                                    users: []
                                }
                                sendGroupUserSetter(sentGroup.users, this.notification.to.groups[i].data.users)
                                if (sentGroup.users.length > 0) {
                                    sentNotificationHistory.to.groups.push(sentGroup)
                                }
                            }
                        }
                        break;
                    case "belong_group":
                        // 選択した所属グループ宛 の時の、to のデータを作成
                        sentNotificationHistory.to = {
                            groups: []
                        }
                        for (var i=0; i<this.notification.to.belongGroups.length; i++) {
                            if (this.notification.to.belongGroups[i].checked) {
                                const sentGroup = {
                                    userUID: this.notification.to.belongGroups[i].data.group.ownerUserUID,
                                    groupNo: this.notification.to.belongGroups[i].data.group.groupNo,
                                    users: []
                                }
                                sendGroupUserSetter(sentGroup.users, this.notification.to.belongGroups[i].data.users)
                                if (sendGroup.users.length > 0) {
                                    sentNotificationHistory.to.groups.push(sentGroup)
                                }
                            }
                        }
                        break;
                    case "group_member":
                        // 特定のグループのメンバー宛 の時の、to のデータを作成
                        const checkedGroup = this.notification.to.groups.find((v)=>v.checked)
                        sentNotificationHistory.to = {
                            users: []
                        }
                        for(var i=0; i<this.notification.to.groupMembers.length; i++){
                            if (this.notification.to.groupMembers[i].checked) {
                                sentNotificationHistory.to.users.push(this.notification.to.groupMembers[i].data.body.userUID)
                            }
                        }
                        break;
                    case "belong_group_member":
                        console.log(this.notification)
                        // 特定の所属グループのメンバー宛 の時の、to のデータを作成
                        const checkedBelongGroup = this.notification.to.belongGroups.find((v)=>v.checked)
                        sentNotificationHistory.to = {
                            users: []
                        }
                        for(var i=0; i<this.notification.to.belongGroupMembers.length; i++){
                            if (this.notification.to.belongGroupMembers[i].checked) {
                                sentNotificationHistory.to.users.push(this.notification.to.belongGroupMembers[i].data.body.userUID)
                            }
                        }
                        break;
                    case "reply":
                        // 返信の時の、to のデータを作成
                        sentNotificationHistory.to = {
                            userUID: this.replyTargetNotification.body.sender.userUID 
                        }
                        break;
                }

                console.log("sentNotificationHistory", sentNotificationHistory)

                // {type:"all", text:"全グループと全所属グループ宛"},
                // {type:"group_all", text:"全グループ宛"},
                // {type:"group", text:"選択したグループ宛"},
                // {type:"group_member", text:"特定のグループのメンバー宛"},
                // {type:"belong_group_all", text:"全所属グループ宛"},
                // {type:"belong_group", text:"選択した所属グループ宛"},
                // {type:"belong_group_member", text:"特定の所属グループのメンバー宛"},

                this.$store.commit("processing", {start:true})

                try {
                    var batch = db.batch()

                    // 通知を登録
                    switch (this.notification.to.targetType) {
                        case "all":
                        case "group_all":
                        case "group":
                        case "belong_group_all":
                        case "belong_group":
                            for (var i=0; i<sentNotificationHistory.to.groups.length; i++) {
                                const group = sentNotificationHistory.to.groups[i]
                                for (var j=0; j<group.users.length; j++) {
                                    const userUID = group.users[j]
                                    batch.set(db.collection("users").doc(userUID).collection("notifications").doc(id), notification)
                                }
                            }
                            break;
                        case "group_member":
                            for (var i=0; i<sentNotificationHistory.to.users.length; i++) {
                                const userUID = sentNotificationHistory.to.users[i]
                                batch.set(db.collection("users").doc(userUID).collection("notifications").doc(id), notification)
                            }
                            break;
                        case "belong_group_member":
                            for (var i=0; i<sentNotificationHistory.to.users.length; i++) {
                                const userUID = sentNotificationHistory.to.users[i]
                                batch.set(db.collection("users").doc(userUID).collection("notifications").doc(id), notification)
                            }
                            break;
                        case "reply":
                            batch.set(db.collection("users").doc(this.replyTargetNotification.body.sender.userUID).collection("notifications").doc(id), notification)
                            break;
                    }
                    
                    // 通知の送信履歴
                    console.log("notification history writing", sentNotificationHistory)
                    batch.set(db.collection("users").doc(this.userUID).collection("sent_notifications").doc(id), sentNotificationHistory)

                    // コミット
                    batch.commit().then(function(){
                        console.log("通知成功")
                        self.$store.commit("notification", {message:"通知を送信しました。"})
                        self.$store.commit("processing")
                        self.$emit("onSentNotification", sentNotificationHistory)
                        self.isView = false
                    }).catch (function(error){
                        console.log(error)
                        self.$store.commit("notification", {message:"通知の送信に失敗しました。", isError:true})
                        self.$store.commit("processing")
                    })
                } catch (error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"通知の送信に失敗しました。", isError:true})
                    self.$store.commit("processing")
                }
            },
        }
    }
</script>

<style scoped>
    .balloon2-left {
        position: relative;
        display: inline-block;
        margin: 1.5em 0 1.5em 15px;
        padding: 0px 10px;
        min-width: 120px;
        max-width: 100%;
        color: #555;
        font-size: 16px;
        background: #FFF;
        border: solid 3px #555;
        border-radius: 8px;
        box-sizing: border-box;
    }

    .balloon2-left:before {
        content: "";
        position: absolute;
        top: 24px;
        left: -22px;
        margin-top: -12px;
        border: 12px solid transparent;
        border-right: 12px solid #FFF;
        z-index: 2;
    }

    .balloon2-left:after {
        content: "";
        position: absolute;
        top: 24px;
        left: -28px;
        margin-top: -14px;
        border: 14px solid transparent;
        border-right: 14px solid #555;
        z-index: 1;
    }

    .balloon2-left p {
        margin: 0;
        padding: 0;
    }
</style>
